import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import Spinner from "react-bootstrap/Spinner";
import jsonData from "./ai-branding.json"; // Import the JSON file
import appversion from '../package.json';
import { useHyperlink } from "./contexts/HyperlinkProvider.js";
import usePavanData from "./hooks/usePavanData";


const Footer = lazy(() => import("./components/CommenFooterComponent/index.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));




function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;
  
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("")
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
  const pavanData = usePavanData();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink || "Sun West Mortgage Company, Inc.")
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);



  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_MASTERMINDAPRILJSON_CDN_URL)
        .then(response => {          
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();
  }, []);

  return (

   
    <div className="bodyContainer">
      <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
       {links ? (
      <> 
      <Header fetchpriority="high" links={links.current}/>      
      {bannerData ?
      <>      
      <Body bannerData={bannerData} timerData={timerData} formData={formData} fetchpriority="high" links={links.current}/>            
        
      {/* <Suspense fallback={<div />}>
      <LogoSection fetchpriority="low" />
      </Suspense> */}
      <Suspense fallback={<div />}>
      {highlightsData ?
        <Highlights highlightsData={highlightsData} />
        : ""}
      </Suspense> 
      <Suspense fallback={<div />}>
      {propertyData ?
        <Proprty propertyData={propertyData} />
        : ""}
      </Suspense> 
      <Suspense fallback={<div />}>   
      <Morganlogos links={links.current} sunwestLink={sunwestLink} angelAiLink={angelAiLink}/>  
      </Suspense> 
      <Suspense fallback={<div />}>   
      <Whysunwest links={links.current} sunwestLink={sunwestLink} swmcLink={swmcLink} pavanLink={pavanLink} pavanData={pavanData}/>  
      </Suspense>  
      <Suspense fallback={<div />}>
      <Footer />
      </Suspense>         
      </>
         : ""}  
          </>
    ) : (
      <div>Loading...</div>
    )}
    </CacheBuster>
    </div>
  );
}

export default App;
